import { render, staticRenderFns } from "./PhysicalSpacesTable.vue?vue&type=template&id=f3e523b4&"
import script from "./PhysicalSpacesTable.vue?vue&type=script&lang=js&"
export * from "./PhysicalSpacesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports